const resource = '/shop-api/currencies'

export default (ctx, $axios) => ({
  getCurrencies () {
    return $axios.$get(`${resource}`);
  },
})
